import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Breadcrumb, CatalogPage, Campaign } from '@vestiaire/api-sdk-angular';

@Component({
  selector: 'vc-catalog-header',
  templateUrl: './catalog-header.component.html',
  styleUrls: ['./catalog-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CatalogHeaderComponent {
  @Input()
  seoTags: any;
  @Input()
  configHeader: any;
  @Input()
  data: CatalogPage | null;
  @Input()
  breadcrumb: Array<Breadcrumb> = [];
  @Input()
  isMobile: boolean;
  @Input()
  campaign: Campaign;

  get isBrandPage(): boolean {
    return this.data.template === 'brand-page';
  }
}
